module.exports = __webpack_public_path__ + "img/Group 266@2x (1).c1a065da.png";